import React from 'react'
import { UserPrescreenedPositionsTable } from './UserPrescreenedPositionsTable'

export const UserPrescreenedPositionsMain = () => {
  return <UserPrescreenedPositionsTable />
}
